const qrcode = require('qrcode-generator/qrcode');

// Prepares the QR-code.
// Supports both V1 (data-uuid) and V2 (data-id)
//
const generateQR = () => {
    const placeholder = document.getElementById('js_qrPlaceholder');
    if (placeholder === null) {
        return;
    }

    // Support both V1 (UUID) and V2 (UUID)
    const identifier = placeholder.getAttribute('data-uuid');
    if (!identifier) {
        return;
    }

    // QR relevant variables.
    const typeNumber = 0;
    const errorCorrectionLevel = 'L';
    const qr = qrcode(typeNumber, errorCorrectionLevel);

    qr.addData(identifier);
    qr.make();
    placeholder.innerHTML = qr.createImgTag(8, 4);
};

export { generateQR };